@reference "~/styles.css";

@layer components {
	.star {
		@apply grid size-5 text-grey-500 items-center justify-center outline-none;
		/* TODO OBSFE-106 prefer hover:not-aria-readonly */
		@apply hover:text-yellow-500;
		@apply aria-readonly:text-grey-500 aria-readonly:cursor-[inherit];
		@apply focus-visible:ring-highlight;
		@apply cursor-pointer;
	}

	.icon {
		@apply col-start-1 col-end-2 row-start-1 row-end-2 pointer-events-none motion-safe:transition-colors;
	}

	.iconFull {
		@apply text-yellow-500 scale-[300%] opacity-0 ease-out transform-cpu motion-safe:transition-[transform,opacity] motion-safe:duration-300;

		.star[aria-checked="true"] & {
			@apply scale-100 opacity-100;
		}
	}
}
